import { Hero } from "./Hero";
import { AAMiddleware } from "../../../../store/AAMiddleware";
import { UserCollections } from "./Balances/UserCollections";
import { ITabItem, TabbedContent } from "../../../../components/TabbedContent";
import { useEffect, useState } from "react";
import { BalancesLayout } from "../CollectionManage";
import { BuildingBank, Stack } from "tabler-icons-react";
import { Container } from "@mantine/core";

const api = new AAMiddleware()

export function Main() {

    const [config,setConfig] = useState<any>()
    const [supportedTokens,setSupportedTokens] = useState([] as any)

    useEffect(()=>{
        const loadConfig = async () => {
            const newConfig = await api.getBackedConfig()
            if ( newConfig ) {
                setConfig(newConfig)
            }
        }
        loadConfig()
    },[])

    useEffect(()=>{
        const loadBackedCollection = async () => {
            if ( ! config ) { return }
            const tokens = config.supported_tokens.map(t=>t.symbol.split(',')[1])
            setSupportedTokens(tokens)
        }
        loadBackedCollection()
    },[config])

    const tabItems : ITabItem[] = [
        { 
            label: 'Balances',
            content: <BalancesLayout supportedTokens={supportedTokens} />,
            icon: BuildingBank,
            visible: true,
        },
        { 
            label: 'Collections',
            content: <UserCollections />,
            icon: Stack,
            visible: true,
        },
    ]

    return (
        <>
            <Hero />
            {
                supportedTokens.length ? 
                (
                    <Container px='xl' py='xl'>
                        <TabbedContent items={tabItems} />
                    </Container>
                )
                : ''
            }
        </>
    )
}